// AUTO-GENERATED by scripts/gen-blog-index.ts — do not edit by hand.
import type { BlogCardMeta } from "./blog-index.th.gen";
export type { BlogCardMeta, BlogCategory } from "./blog-index.th.gen";

export const BLOG_INDEX_EN: BlogCardMeta[] = [
 {
  "slug": "apostille-thailand-2024-guide",
  "title": "How Thailand's 2024 Apostille Accession Changes Your Paperwork",
  "category": "Apostille",
  "tags": [
   "apostille",
   "MFA",
   "legalization",
   "thailand"
  ],
  "readMinutes": 8,
  "excerpt": "After 60+ years of relying on dual legalization, Thailand's Ministry of Foreign Affairs now issues Apostilles accepted in 125+ Hague countries. This guide explains exactly what changed for expats.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-03-10",
  "updatedAt": "2026-05-20"
 },
 {
  "slug": "marriage-thailand-foreigners",
  "title": "Marrying in Thailand as a Foreigner — Document Checklist by Embassy",
  "category": "Marriage",
  "tags": [
   "marriage",
   "thai marriage",
   "embassy affirmation"
  ],
  "readMinutes": 10,
  "excerpt": "Marrying in Thailand requires an embassy affirmation, a sworn Thai translation, and an MFA stamp before the amphur will register your marriage. Here's the full embassy-by-embassy breakdown.",
  "author": "Attorney Somchai L.",
  "publishedAt": "2026-02-22",
  "updatedAt": "2026-05-18"
 },
 {
  "slug": "non-b-vs-ltr-vs-dtv",
  "title": "Non-B vs LTR vs DTV: Which Thai Visa Fits Your 2026 Plans?",
  "category": "Visa",
  "tags": [
   "LTR",
   "DTV",
   "Non-B",
   "thai visa"
  ],
  "readMinutes": 12,
  "excerpt": "Three popular long-stay options for foreigners in Thailand. Each has different income thresholds, tax treatment, and family-inclusion rules. Here's a clear decision framework.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-01-30",
  "updatedAt": "2026-05-25"
 },
 {
  "slug": "notarised-poa-thailand",
  "title": "Notarised Power of Attorney in Thailand — When & How",
  "category": "Notary",
  "tags": [
   "POA",
   "power of attorney",
   "notary",
   "notarial-services-attorney"
  ],
  "readMinutes": 6,
  "excerpt": "A Power of Attorney lets someone act on your behalf for property, banking, court, or immigration matters. In Thailand it must be notarised by a Notarial Services Attorney, not a regular notary.",
  "author": "Attorney Pichaya R.",
  "publishedAt": "2026-02-05",
  "updatedAt": "2026-05-12"
 },
 {
  "slug": "translating-birth-certificate-th-en",
  "title": "Translating a Thai Birth Certificate for Foreign Embassies",
  "category": "Translation",
  "tags": [
   "birth certificate",
   "sworn translation",
   "MFA"
  ],
  "readMinutes": 5,
  "excerpt": "A Thai birth certificate (Sor Chor 19) needs three things before a foreign embassy will accept it: a sworn translation, MFA legalization or Apostille, and (for non-Hague countries) embassy stamp.",
  "author": "NYC Translation Team",
  "publishedAt": "2026-01-18",
  "updatedAt": "2026-05-08"
 },
 {
  "slug": "mfa-legalization-walkthrough",
  "title": "MFA Legalization (Chaeng Wattana) — A Visual Walkthrough",
  "category": "Legalization",
  "tags": [
   "MFA",
   "Chaeng Wattana",
   "legalization"
  ],
  "readMinutes": 7,
  "excerpt": "The MFA's Department of Consular Affairs in Chaeng Wattana legalises ~3,000 documents per day. Here's exactly what happens between walking in and walking out with stamped papers.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-02-14",
  "updatedAt": "2026-05-22"
 },
 {
  "slug": "criminal-record-check-thailand-expats",
  "title": "Thai Police Clearance for Expats — How to Get It Abroad",
  "category": "Translation",
  "tags": [
   "police clearance",
   "criminal record",
   "PCC",
   "fingerprint"
  ],
  "readMinutes": 8,
  "excerpt": "A Thai Police Clearance Certificate (PCC) is required for many overseas visa applications including UK Skilled Worker, Australian PR, Canadian PR, and German residence permits.",
  "author": "Attorney Somchai L.",
  "publishedAt": "2026-03-02",
  "updatedAt": "2026-05-19"
 },
 {
  "slug": "naati-translation-australia-visa",
  "title": "NAATI Certified Translation — What Australian Visas Require",
  "category": "Translation",
  "tags": [
   "NAATI",
   "Australia visa",
   "certified translation"
  ],
  "readMinutes": 6,
  "excerpt": "The Department of Home Affairs requires every non-English document in your Australian visa application to be translated by a NAATI-credentialed translator. Here's how it works from Thailand.",
  "author": "NYC Translation Team",
  "publishedAt": "2026-03-22",
  "updatedAt": "2026-05-26"
 },
 {
  "slug": "work-permit-thailand-2026",
  "title": "Thailand Work Permit 2026 — Documents, Timeline, and Common Mistakes",
  "category": "Work Permit",
  "tags": [
   "work permit",
   "Non-B",
   "Thai labour"
  ],
  "readMinutes": 9,
  "excerpt": "Working legally in Thailand requires a Work Permit (WP3) issued by the Department of Employment. Process changed in 2024 with the e-Workpermit platform — here's the current state.",
  "author": "Attorney Pichaya R.",
  "publishedAt": "2026-03-15",
  "updatedAt": "2026-05-24"
 },
 {
  "slug": "embassy-legalization-non-hague-countries",
  "title": "Embassy Legalization for Non-Hague Countries — UAE, China, Vietnam",
  "category": "Legalization",
  "tags": [
   "embassy legalization",
   "UAE",
   "China",
   "Vietnam"
  ],
  "readMinutes": 8,
  "excerpt": "If your destination country isn't a Hague Apostille member, you need the old two-step legalization: MFA Bangkok + destination embassy in Bangkok. Here's the timeline and cost per country.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-04-08",
  "updatedAt": "2026-05-28"
 },
 {
  "slug": "hague-apostille-thailand-2-year-update-2026",
  "title": "Two Years In: How Thailand's Hague Apostille Is Working in 2026",
  "category": "Apostille",
  "tags": [
   "Apostille",
   "Hague Convention",
   "MFA Legalization",
   "Thailand"
  ],
  "readMinutes": 10,
  "excerpt": "Two years after Thailand's accession to the Hague Apostille Convention took effect on 15 December 2024, here is a practitioner's status report: which destinations now accept Apostille, which still require the old dual legalization chain, current MFA fees and turnaround times, and the most common mistakes foreigners make.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "same-sex-marriage-thailand-2026-foreigner-guide",
  "title": "Same-Sex Marriage in Thailand 2026 — A Complete Guide for Foreign Couples",
  "category": "Marriage",
  "tags": [
   "Same-Sex Marriage",
   "Marriage Equality",
   "Thailand",
   "LGBTQ+"
  ],
  "readMinutes": 12,
  "excerpt": "On 23 January 2025 the Marriage Equality Act (Act Amending the Civil and Commercial Code, No. 24) came into force, making Thailand the first country in Southeast Asia to legalize same-sex marriage. This guide walks foreign same-sex couples through the full document and registration workflow at any Thai district office (Amphoe), and explains how to make the marriage legally recognized in your home country.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "naati-translation-matrix-australian-agencies-2026",
  "title": "NAATI Translation Matrix 2026 — Which Document Goes to Which Australian Agency",
  "category": "Translation",
  "tags": [
   "NAATI",
   "Australia",
   "DHA",
   "AHPRA",
   "VETASSESS",
   "Engineers Australia"
  ],
  "readMinutes": 12,
  "excerpt": "Thai applicants for Australian visas, skills assessments, and professional registration deal with at least seven different agencies, each with its own document-format expectations. This matrix maps every commonly-needed Thai document to the agency that requires it, the NAATI translation format expected, and the 2026 fee/turnaround per pathway.",
  "author": "NYC NAATI Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "ltr-wealthy-pensioner-visa-thailand-2026-guide",
  "title": "Thailand LTR Wealthy Pensioner Visa 2026 — Complete Guide for Retirees Aged 50+",
  "category": "Visa",
  "tags": [
   "LTR Visa",
   "Retirement Visa",
   "BOI",
   "Wealthy Pensioner",
   "Long-Term Resident"
  ],
  "readMinutes": 13,
  "excerpt": "Thailand's Long-Term Resident (LTR) Wealthy Pensioner category — launched September 2022 and refined through 2025-2026 — offers retirees aged 50+ a 10-year renewable visa, multi-entry stamps, a single 90-day reporting cycle, and a 17% income tax cap on Thai-sourced earnings. This guide breaks down the 2026 eligibility, the BOI application process, document checklist, and how the LTR-WP compares to the older O-A Retirement and the Thailand Privilege visas.",
  "author": "NYC Visa Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "us-k1-fiance-visa-thailand-document-pack-2026",
  "title": "US K-1 Fiancé(e) Visa from Thailand 2026 — Complete Document Pack",
  "category": "Visa",
  "tags": [
   "K-1",
   "Fiance Visa",
   "US Embassy Bangkok",
   "Apostille",
   "USCIS"
  ],
  "readMinutes": 14,
  "excerpt": "Every Thai fiancé(e) of a US citizen must clear three agencies — USCIS, NVC, and US Embassy Bangkok — across roughly 10 months. This guide maps every document, apostille step, and translation requirement.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-23",
  "updatedAt": "2026-06-23"
 },
 {
  "slug": "thailand-tax-residency-foreign-income-2026-guide",
  "title": "Thailand Tax Residency and Foreign Income 2026 — Expat Survival Guide",
  "category": "Visa",
  "tags": [
   "Tax Residency",
   "Foreign Income",
   "Por 161",
   "Por 162",
   "LTR",
   "DTA"
  ],
  "readMinutes": 16,
  "excerpt": "Thailand's Revenue Department reversed 40 years of practice in late 2023. This guide explains exactly when foreign income becomes taxable, who is exempt, and how to file under the new Por 161/162 regime.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "apostille-uk-thailand-corridor-2026",
  "title": "UK ↔ Thailand Apostille Corridor 2026 — Spouse Visa, Skilled Worker & Ecctis Walkthrough",
  "category": "Apostille",
  "tags": [
   "uk",
   "apostille",
   "spouse visa",
   "skilled worker",
   "fcdo",
   "ecctis"
  ],
  "readMinutes": 11,
  "excerpt": "The complete 2026 playbook for UK ↔ Thailand document flow: when to apostille in Bangkok vs. Milton Keynes, how to clear the £29,000 spouse threshold, when Ecctis is mandatory, and the exact sequence from Thai documents to a UK Biometric Residence Permit.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-canada-thailand-corridor-2026",
  "title": "Canada ↔ Thailand Apostille Corridor 2026 — Express Entry, WES & Spousal Sponsorship",
  "category": "Apostille",
  "tags": [
   "canada",
   "apostille",
   "express entry",
   "spousal sponsorship",
   "wes",
   "ircc"
  ],
  "readMinutes": 11,
  "excerpt": "Canada's January 2024 Apostille accession transformed Thailand ↔ Canada paperwork. This guide covers the IRCC portal workflow for Express Entry, the WES ECA process, Spousal Sponsorship (Inland vs Outland), PNP options, and 2026 CRS cut-offs.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-australia-thailand-corridor-2026",
  "title": "Australia ↔ Thailand Apostille Corridor 2026 — Partner Visa, Skilled Migration & NAATI",
  "category": "Apostille",
  "tags": [
   "australia",
   "apostille",
   "partner visa",
   "skilled migration",
   "naati",
   "immi"
  ],
  "readMinutes": 12,
  "excerpt": "Australia is a Hague Apostille member since 1995 — but Thai documents still need a precise NAATI-Certified translation chain to land in ImmiAccount. This guide covers Partner Visas, Skilled Migration points, Skill Assessment authorities, and the end-to-end workflow.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-new-zealand-thailand-corridor-2026",
  "title": "New Zealand ↔ Thailand Apostille Corridor 2026 — Partner, Skilled Migrant & NZQA",
  "category": "Apostille",
  "tags": [
   "new zealand",
   "apostille",
   "smc",
   "partner visa",
   "nzqa",
   "aewv"
  ],
  "readMinutes": 11,
  "excerpt": "New Zealand's Skilled Migrant Category was overhauled in October 2023 to a simplified 6-point system. This guide maps the corridor — DIA Apostille, NZQA IQA for Thai qualifications, AEWV 3-Check system, and end-to-end Thailand to Wellington workflow.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-japan-thailand-corridor-2026",
  "title": "Japan ↔ Thailand Apostille Corridor 2026 — Spouse Visa, HSP & Engineer Routes",
  "category": "Apostille",
  "tags": [
   "japan",
   "apostille",
   "spouse visa",
   "hsp",
   "engineer visa"
  ],
  "readMinutes": 12,
  "excerpt": "Both Japan (Hague member since 1970) and Thailand (since July 2024) issue Apostilles. This guide details the MOFA Japan whitelist, Ward Office Kekkon Todoke registration, and 2026 HSP/Engineer thresholds for Thai applicants.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-korea-thailand-corridor-2026",
  "title": "South Korea ↔ Thailand Apostille Corridor 2026 — F-6, E-7 & D-2 Visas",
  "category": "Apostille",
  "tags": [
   "korea",
   "apostille",
   "f-6 visa",
   "e-7 visa",
   "d-2 student"
  ],
  "readMinutes": 12,
  "excerpt": "South Korea (Hague member since 2007) and Thailand (since July 2024) operate a fully bidirectional Apostille corridor. This guide covers F-6, E-7, D-2 visas plus the mandatory KCUE diploma verification and HiKorea online lodgement.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-germany-thailand-corridor-2026",
  "title": "Germany ↔ Thailand Apostille Corridor 2026: Standesamt, Anabin, Blue Card & Skilled Migration",
  "category": "Apostille",
  "tags": [
   "apostille",
   "germany",
   "blue-card",
   "standesamt",
   "anabin"
  ],
  "readMinutes": 16,
  "excerpt": "Germany is Thailand's largest EU trading partner and a top destination for Thai skilled migrants under the 2023 Skilled Immigration Act. With both countries on the Hague Apostille Convention since 2024, the corridor now runs on a clean three-step chain — but Anabin database checks, beeidigte Übersetzer translation rules, and Standesamt local-office variances still trip up applicants.",
  "author": "Apostille Corridor Desk",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-france-thailand-corridor-2026",
  "title": "France ↔ Thailand Apostille Corridor 2026: Mairie, PACS, Traducteur Assermenté & VLS-TS",
  "category": "Apostille",
  "tags": [
   "apostille",
   "france",
   "vls-ts",
   "mairie",
   "pacs",
   "talent-passport"
  ],
  "readMinutes": 16,
  "excerpt": "France is Thailand's 3rd-largest EU partner with ~25,000 Thai nationals residing under various Cartes de Séjour. The 2024 Hague entry simplified document chains but introduced new constraints — traducteur assermenté at Cour d'Appel level, OFII medical visit, and dual-route choice between mariage civil and PACS each carry distinct paperwork and timeline impacts.",
  "author": "Apostille Corridor Desk",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "schengen-visa-from-thailand-2026-complete-guide",
  "title": "Schengen Visa from Thailand 2026: Complete Application Guide for Thai & Foreign Residents",
  "category": "Visa",
  "tags": [
   "schengen",
   "visa",
   "europe",
   "etias",
   "ees"
  ],
  "readMinutes": 16,
  "excerpt": "The Schengen Area covers 29 European countries (27 EU + Switzerland + Norway + Iceland + Liechtenstein, minus Ireland and Cyprus) with a single uniform short-stay visa. With EES biometric entry/exit live since 10 October 2025 and ETIAS launching Q4 2026, Thai-issued Schengen visas now sit inside a fully digital border ecosystem — but the application paperwork is unchanged.",
  "author": "Visa Desk",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "saudi-arabia-work-visa-document-legalization-thailand-2026",
  "title": "Saudi Arabia Work Visa from Thailand 2026: Document Legalization, Saudization & Vision 2030",
  "category": "Visa",
  "tags": [
   "saudi-arabia",
   "work-visa",
   "legalization",
   "iqama",
   "vision-2030"
  ],
  "readMinutes": 16,
  "excerpt": "Saudi Arabia is Thailand's largest Middle East trade partner since the 2022 Saudi-Thai relations restoration. With Vision 2030 mega-projects (NEOM, The Red Sea, Qiddiya, Diriyah, AlUla) creating ~120,000 expat positions for Thai workers in construction, hospitality, healthcare, and engineering through 2030, the Saudi work visa pipeline runs through a strict 5-step legalization chain that NYC streamlines.",
  "author": "Embassy Legalization Desk",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "dtv-destination-thailand-visa-complete-guide-2026",
  "title": "DTV Destination Thailand Visa 2026: Digital Nomad, Soft Power, Remote Worker Complete Guide",
  "category": "Visa",
  "tags": [
   "dtv",
   "digital-nomad",
   "remote-work",
   "thailand-visa",
   "soft-power"
  ],
  "readMinutes": 16,
  "excerpt": "Launched 15 July 2024, the Destination Thailand Visa (DTV) is Thailand's most flexible long-stay visa — 5 years multi-entry, 180-day permitted stays per entry (extendable by 180 days inside Thailand), eligible to remote workers worldwide and to anyone enrolled in Thai soft-power activities (Muay Thai, Thai cooking, traditional medicine, sports training). At THB 10,000 with online application via Thai e-Visa portal, the DTV has issued ~85,000 visas in its first 18 months.",
  "author": "Thailand Visa Desk",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "uae-thailand-document-legalization-corridor-2026",
  "title": "UAE ↔ Thailand Document Legalization Corridor 2026: Golden Visa, Free-Zone Employment & Family Sponsorship",
  "category": "Legalization",
  "tags": [
   "uae",
   "dubai",
   "abu-dhabi",
   "golden-visa",
   "mofaic",
   "free-zone"
  ],
  "readMinutes": 18,
  "excerpt": "UAE never joined the Hague Apostille Convention. Every Thai-issued document destined for Dubai, Abu Dhabi, Sharjah, or free zones (DMCC, DIFC, ADGM, JAFZA) requires the full 4-step legalization chain: MFA Bangkok → UAE Embassy Bangkok → MOFAIC Dubai/Abu Dhabi → end-user authority (MOHRE, GDRFA, MOE, court). Conversely, UAE-issued documents for Thailand need MOFAIC + Thai Embassy Abu Dhabi stamping. This guide covers Golden Visa investment thresholds (AED 2M property, AED 2M business, scientist/specialist categories), Equivalency Certificates for engineering/medical professionals, family sponsorship salary requirements (AED 4,000+ housing), and the 2025 Federal Decree-Law on Personal Status that simplified expat family law.",
  "author": "NYC Editorial Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "singapore-thailand-document-corridor-2026",
  "title": "Singapore ↔ Thailand Document Corridor 2026: Apostille, EP/PEP, Tech.Pass & Family Schemes",
  "category": "Apostille",
  "tags": [
   "singapore",
   "apostille",
   "employment-pass",
   "tech-pass",
   "one-pass"
  ],
  "readMinutes": 17,
  "excerpt": "Singapore acceded to the Hague Apostille Convention on 16 September 2021 — both Thailand (since 24 December 2024) and Singapore are now Convention members, eliminating the previous 4-step Embassy chain. Singapore documents for Thailand: SAL (Singapore Academy of Law) Apostille → Thai translation → MFA Bangkok translation legalization. Thailand documents for Singapore: MFA Bangkok Apostille → direct submission to MOM, ICA, MOE, MAS, ACRA, Family Justice Courts. This bilateral simplification cuts 10-14 days off every corridor transaction. Below: Employment Pass tiered salaries (S$5,000-10,500 by sector + age), Personalised EP (PEP), Tech.Pass for AI/blockchain/Web3, ONE Pass for top talent, Dependant Pass, and the 2025 LTVP+ extension to same-sex partners.",
  "author": "NYC Editorial Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "qatar-work-visa-thai-2026",
  "title": "Qatar Work Visa & Document Legalization for Thai Professionals 2026",
  "category": "Legalization",
  "tags": [
   "qatar",
   "embassy",
   "legalization",
   "work-visa",
   "gcc"
  ],
  "readMinutes": 11,
  "excerpt": "Qatar's labor reform post-2022 World Cup opened skilled-worker channels for Thai engineers, hospitality professionals, healthcare workers, and educators. Because Qatar is not yet an Apostille member, all Thai documents follow the classic 3-step legalization chain — MOFA Thailand + Qatar Embassy Bangkok + MOFA Qatar Doha.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "taiwan-work-visa-thai-2026",
  "title": "Taiwan Work Visa & Document Authentication for Thai Professionals 2026",
  "category": "Legalization",
  "tags": [
   "taiwan",
   "teco",
   "gold-card",
   "work-visa",
   "east-asia"
  ],
  "readMinutes": 11,
  "excerpt": "Taiwan's Employment Gold Card has attracted 10,000+ international professionals since 2018 — Thais are eligible under 8 categories from tech to finance. Because Taiwan is not a Hague Apostille member (UN status), documents require TECO Bangkok authentication instead.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "india-document-legalization-thai-2026",
  "title": "India Apostille for Thai Documents 2026 — Post-Hague Era Guide",
  "category": "Apostille",
  "tags": [
   "india",
   "apostille",
   "oci",
   "work-visa",
   "south-asia"
  ],
  "readMinutes": 11,
  "excerpt": "India acceded to the Hague Apostille Convention in 2005 — so since Thailand's December 2024 accession, the Thailand-India corridor enjoys streamlined single-Apostille document flow. Combined with India's rising tech/manufacturing demand and OCI (Overseas Citizen of India) reforms, the corridor is increasingly active for Thai professionals.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "malaysia-document-legalization-thai-2026",
  "title": "Malaysia Document Legalization for Thai Citizens 2026: Apostille, Work Visa & MM2H",
  "category": "Legalization",
  "tags": [
   "malaysia",
   "apostille",
   "mm2h",
   "employment-pass",
   "asean"
  ],
  "readMinutes": 11,
  "excerpt": "Malaysia acceded to the Hague Apostille Convention with entry-into-force 16 December 2024. Thai documents now flow directly to KL with a single MFA stamp — no more dual legalization.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-27",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "vietnam-document-legalization-thai-2026",
  "title": "Vietnam Document Legalization for Thai Citizens 2026: Embassy Route, Work Permit & TRC",
  "category": "Legalization",
  "tags": [
   "vietnam",
   "embassy-legalization",
   "work-permit",
   "trc",
   "asean"
  ],
  "readMinutes": 11,
  "excerpt": "Unlike Malaysia and Singapore, Vietnam has not acceded to the Hague Apostille Convention. Thai documents still require dual legalization via MFA Bangkok + Vietnamese Embassy. Here is the full 2026 corridor playbook.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-27",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "naati-certified-translation-thailand-2026-australia-visa-guide",
  "title": "NAATI Certified Translation in Thailand 2026 — Complete Guide for Australian Visas",
  "category": "Translation",
  "tags": [
   "NAATI",
   "australia",
   "PR",
   "skilled-migration",
   "CCL"
  ],
  "readMinutes": 14,
  "excerpt": "Everything Thai-Australian migrants need to know about NAATI Certified Translation — from Partner Visa 820/801 through Skilled 189/190 to CCL Test for +5 PR points.",
  "author": "NYC Translation Bureau",
  "publishedAt": "2026-06-20",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "naati-ccl-test-thailand-2026-complete-prep-guide",
  "title": "NAATI CCL Test in Thailand 2026 — Complete Prep Guide for +5 PR Points (Thai-English)",
  "category": "Translation",
  "tags": [
   "NAATI",
   "CCL",
   "skilled-migration",
   "PR",
   "189",
   "190",
   "491"
  ],
  "readMinutes": 16,
  "excerpt": "Step-by-step CCL Test preparation guide for Thai-English candidates — what the exam tests, how to pass on the first attempt, and why +5 points is the highest-ROI move in Skilled Migration.",
  "author": "NYC Translation Bureau",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "thai-police-clearance-certificate-2026-complete-global-migration-guide",
  "title": "Thai Police Clearance Certificate 2026 — Complete Global Migration Guide",
  "category": "Legalization",
  "tags": [
   "police clearance",
   "migration",
   "apostille",
   "embassy",
   "thai immigration"
  ],
  "readMinutes": 14,
  "excerpt": "A practical 2026 guide to the Thai Police Clearance Certificate for migration — filing, fingerprints, MFA Apostille vs. legalisation, validity per country, and how to avoid the three errors that cause 90% of refusals.",
  "author": "NYC Legal Editorial",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "mfa-legalisation-vs-apostille-thailand-2026-complete-comparison",
  "title": "MFA Legalisation vs Apostille Thailand 2026 — Complete Comparison Guide",
  "category": "Apostille",
  "tags": [
   "apostille",
   "legalisation",
   "mfa",
   "hague convention",
   "consular"
  ],
  "readMinutes": 16,
  "excerpt": "Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027). This guide answers the question every applicant now asks: Apostille or Legalisation — and proves it with a country-by-country decision tree.",
  "author": "NYC Legal Editorial",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "gcc-embassy-legalisation-thailand-2026-complete-guide",
  "title": "GCC Embassy Legalisation in Thailand 2026 — UAE, Saudi Arabia, Kuwait & Qatar Complete Guide",
  "category": "Legalization",
  "tags": [
   "embassy",
   "UAE",
   "saudi-arabia",
   "kuwait",
   "qatar",
   "GCC",
   "legalization"
  ],
  "readMinutes": 12,
  "excerpt": "Even after Thailand's 2024 Hague accession, every Gulf Cooperation Council (GCC) embassy in Bangkok still requires the traditional MFA + Consular Legalisation chain. This guide maps every fee, queue, and document requirement so you can plan a GCC employment, family-visa, or commercial filing without surprises.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "japan-document-legalization-corridor",
  "title": "Japan Document Legalisation from Thailand 2026 — Apostille, Translation & Embassy Workflow",
  "category": "Legalization",
  "tags": [
   "japan",
   "apostille",
   "embassy",
   "legalization",
   "translation-japanese"
  ],
  "readMinutes": 11,
  "excerpt": "Japan acceded to the Hague Apostille Convention in 1970 — so Thai-issued documents bearing an MFA Apostille are accepted in Japan without embassy legalisation. This guide maps the entire 2026 corridor from a Thai-language source document to acceptance at the Tokyo Legal Affairs Bureau, Immigration Services Agency (ISA), and ward office (kuyakusho).",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "south-korea-document-legalization-corridor",
  "title": "South Korea Document Legalisation from Thailand 2026 — Apostille, K-ETA, F-Visa Complete Guide",
  "category": "Legalization",
  "tags": [
   "south-korea",
   "apostille",
   "embassy",
   "legalization",
   "F-visa",
   "translation-korean"
  ],
  "readMinutes": 11,
  "excerpt": "South Korea joined the Hague Apostille Convention on 14 July 2007. Combined with Thailand's December 2023 accession, the corridor is now Apostille-only — no Korean Embassy legalisation required for civil, academic, or commercial documents.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "india-document-legalization-corridor",
  "title": "Thai Documents for India 2026 — Post-Hague Apostille Corridor",
  "category": "Legalization",
  "tags": [
   "india",
   "apostille",
   "OCI",
   "MEA",
   "legalization"
  ],
  "readMinutes": 9,
  "excerpt": "India has been a Hague Apostille party since 2005; Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027). The Thai → India corridor now skips the Embassy of India in Bangkok entirely — a single MFA Apostille is sufficient.",
  "author": "NYC Legal Editorial Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "taiwan-document-legalization-corridor",
  "title": "Thai Documents for Taiwan 2026 — TECO Bangkok Corridor",
  "category": "Legalization",
  "tags": [
   "taiwan",
   "TECO",
   "legalization",
   "gold-card",
   "marriage"
  ],
  "readMinutes": 9,
  "excerpt": "Taiwan is not a Hague Apostille member and, due to its UN status, will not join in the foreseeable future. The Thai → Taiwan corridor still requires the full three-step chain: MFA Thailand → TECO Bangkok → MOFA Taipei.",
  "author": "NYC Legal Editorial Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "germany-document-legalization-corridor",
  "title": "Germany Document Legalisation from Thailand — 2026 Complete Guide",
  "category": "Legalization",
  "tags": [
   "germany",
   "apostille",
   "standesamt",
   "zab",
   "sworn-translation"
  ],
  "readMinutes": 11,
  "excerpt": "Since Thailand's Hague accession (28 February 2027), the Germany corridor is now Apostille + vereidigter Übersetzer — no German Embassy Bangkok attestation. NYC closes a typical Familienzusammenführung pack in 9–12 business days.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "china-document-legalization-corridor-2026",
  "title": "China Document Legalisation from Thailand — Post-Hague 2026 Complete Guide",
  "category": "Legalization",
  "tags": [
   "china",
   "apostille",
   "z-visa",
   "residence-permit",
   "notary-office"
  ],
  "readMinutes": 11,
  "excerpt": "China acceded to the Hague Apostille Convention on 7 November 2023. Thailand's accession entered into force 28 February 2027. NYC closes a residence-permit pack in 6–9 business days — no more Chinese Embassy queue.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "france-document-legalization-corridor",
  "title": "France Document Legalisation Corridor 2026: Thai MFA Apostille, Traducteur Assermenté, OFII, Visa Long Séjour",
  "category": "Legalization",
  "tags": [
   "france",
   "apostille",
   "ofii",
   "mairie",
   "traducteur-assermente"
  ],
  "readMinutes": 11,
  "excerpt": "France is a Hague Apostille party since 1965. Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027). The French Embassy in Bangkok no longer legalises Thai documents — but every translation must be re-done in France by a court-sworn translator.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "italy-document-legalization-corridor",
  "title": "Italy Document Legalisation Corridor 2026: Apostille, Dichiarazione di Valore, CIMEA, Comune Marriage",
  "category": "Legalization",
  "tags": [
   "italy",
   "apostille",
   "dichiarazione-di-valore",
   "cimea",
   "comune"
  ],
  "readMinutes": 11,
  "excerpt": "Apostille will replace Italian Embassy legalisation from 28 February 2027 — but Dichiarazione di Valore is still required for university admissions, and CIMEA provides a faster online alternative for €170.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "australia-document-legalization-corridor",
  "title": "Australia Document Legalisation Corridor 2026: Thai MFA Apostille, NAATI Certified Translation, AHPRA, VETASSESS",
  "category": "Legalization",
  "tags": [
   "australia",
   "apostille",
   "naati",
   "ahpra",
   "vetassess"
  ],
  "readMinutes": 11,
  "excerpt": "Australia accepts Thai MFA Apostille directly — but every Thai document must be translated by a NAATI Certified Translator with current CPN. NYC issues NAATI + Apostille in a single workflow.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "spain-document-legalization-corridor",
  "title": "Spain Document Legalisation Corridor 2026: Thai MFA Apostille, Traductor Jurado, NIE & Registro Civil",
  "category": "Legalization",
  "tags": [
   "spain",
   "apostille",
   "traductor-jurado",
   "nie",
   "homologacion"
  ],
  "readMinutes": 11,
  "excerpt": "Spain is Hague Apostille since 1978; with Thailand acceding 28 February 2027 the Spanish Embassy Bangkok will no longer legalise Thai documents. Every translation must be done by a Traductor-Intérprete Jurado appointed by the MAEC.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "uk-document-legalization-corridor",
  "title": "UK Document Legalisation Corridor 2026: Thai MFA Apostille, Home Office, NMC, GMC, ECCTR Marriage",
  "category": "Legalization",
  "tags": [
   "uk",
   "apostille",
   "home-office",
   "nmc",
   "gmc",
   "marriage"
  ],
  "readMinutes": 11,
  "excerpt": "The United Kingdom accepts Thai MFA Apostille directly for every Home Office, NMC, GMC, NARIC ENIC, and General Register Office filing. The UK Embassy Bangkok no longer legalises Thai documents.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "uae-document-legalization-corridor",
  "title": "UAE Document Legalisation Corridor 2026: Thai MFA + UAE Embassy Bangkok + MOFAIC Abu Dhabi Triple Chain",
  "category": "Legalization",
  "tags": [
   "uae",
   "embassy-legalization",
   "mofaic",
   "arabic-translation",
   "mohre"
  ],
  "readMinutes": 12,
  "excerpt": "The UAE is not a Hague Apostille party — Thai documents still require the full triple chain: MFA Bangkok → UAE Embassy Bangkok → MOFAIC Abu Dhabi, followed by Arabic translation by a Ministry of Justice–licensed translator inside the UAE.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "canada-document-legalization-corridor",
  "title": "Canada Document Legalisation Corridor 2026: Thai MFA Apostille, IRCC, WES, NNAS, MCC",
  "category": "Legalization",
  "tags": [
   "canada",
   "apostille",
   "ircc",
   "wes",
   "nnas",
   "quebec"
  ],
  "readMinutes": 11,
  "excerpt": "Canada became a Hague Apostille member on 11 January 2024, eighteen months before Thailand's accession. A Thai MFA Apostille is now accepted directly by IRCC, WES, NNAS, MCC, ICAS, and every provincial vital-statistics office — the Canadian Embassy Bangkok no longer legalises Thai documents.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "switzerland-document-legalization-corridor",
  "title": "Switzerland Document Legalisation Corridor 2026: Thai MFA Apostille, SEM, Zivilstandsamt, Swissmedic, FMH, Cantonal Sworn Translation",
  "category": "Legalization",
  "tags": [
   "switzerland",
   "apostille",
   "sem",
   "zivilstandsamt",
   "fmh",
   "swissmedic"
  ],
  "readMinutes": 11,
  "excerpt": "Switzerland has been a Hague Apostille member since 1973 — the earliest among Continental European destinations. A Thai MFA Apostille is accepted directly by SEM, every cantonal migration office, Zivilstandsamt for marriage transcription, FMH for medical registration, and Swissmedic for pharmaceutical-professional licensing.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "netherlands-document-legalization-corridor",
  "title": "Netherlands Document Legalisation Corridor 2026: Thai MFA Apostille, IND, Gemeente, BIG, Nuffic, beëdigd vertaler",
  "category": "Legalization",
  "tags": [
   "netherlands",
   "apostille",
   "ind",
   "gemeente",
   "big-register",
   "nuffic"
  ],
  "readMinutes": 10,
  "excerpt": "The Netherlands has been a Hague Apostille member since 1965. Thai MFA Apostille is accepted directly by IND, every Gemeente for BRP registration, BIG-register for healthcare, Nuffic for credential evaluation, and the Rechtbank for sworn-translation supervision. The Royal Netherlands Embassy in Bangkok will stop legalising Thai documents on 28 February 2027.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "sweden-document-legalization-corridor",
  "title": "Sweden Document Legalisation Corridor 2026: Thai MFA Apostille, Migrationsverket, Skatteverket, UHR, Socialstyrelsen, Kammarkollegiet sworn translation",
  "category": "Legalization",
  "tags": [
   "sweden",
   "apostille",
   "migrationsverket",
   "skatteverket",
   "uhr",
   "socialstyrelsen"
  ],
  "readMinutes": 11,
  "excerpt": "Sweden has been a Hague Apostille member since 1999. A Thai MFA Apostille is now accepted directly by Migrationsverket, Skatteverket for folkbokföring registration, UHR for academic evaluation, Socialstyrelsen for healthcare licensing, and every tingsrätt. The Swedish Embassy in Bangkok will stop legalising Thai documents on 28 February 2027.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "norway-document-legalization-corridor",
  "title": "Norway Document Legalisation Corridor 2026: Thai MFA Apostille, UDI, Skatteetaten, NOKUT, Helsedirektoratet, statsautorisert translatør",
  "category": "Legalization",
  "tags": [
   "norway",
   "apostille",
   "udi",
   "skatteetaten",
   "nokut",
   "helsedirektoratet"
  ],
  "readMinutes": 11,
  "excerpt": "Norway has been a Hague Apostille member since 1983. A Thai MFA Apostille is accepted directly by UDI, Skatteetaten for folkeregister registration, NOKUT for academic recognition, Helsedirektoratet for healthcare licensing, and every tingrett. The Royal Norwegian Embassy in Bangkok will stop legalising Thai documents on 28 February 2027.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "denmark-document-legalization-corridor",
  "title": "Denmark Document Legalisation Corridor 2026: Thai MFA Apostille, SIRI, Familieretshuset, Patientsikkerhed, UFM, professional translation",
  "category": "Legalization",
  "tags": [
   "denmark",
   "apostille",
   "siri",
   "familieretshuset",
   "ufm",
   "patientsikkerhed"
  ],
  "readMinutes": 10,
  "excerpt": "Denmark has been a Hague Apostille member since 2006 and Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027). A Thai MFA Apostille is accepted directly by SIRI, Familieretshuset, Styrelsen for Patientsikkerhed, the Danish Agency for Higher Education and Science (UFM), and every byret. Uniquely among Nordic destinations, Denmark abolished the sworn-translator monopoly in 2016 — a professional translator's signed declaration suffices.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "belgium-document-legalization-corridor",
  "title": "Belgium Document Legalisation Corridor 2026: Thai MFA Apostille, Office des Étrangers/DVZ, commune/gemeente, INAMI/RIZIV, NARIC, traducteur juré/beëdigd vertaler",
  "category": "Legalization",
  "tags": [
   "belgium",
   "apostille",
   "office-des-etrangers",
   "inami",
   "naric",
   "traducteur-jure"
  ],
  "readMinutes": 11,
  "excerpt": "Belgium has been a Hague Apostille member since 1976. A Thai MFA Apostille is accepted directly by Office des Étrangers/Dienst Vreemdelingenzaken, every commune/gemeente for civil-register transcription, INAMI/RIZIV for healthcare licensing, NARIC-Vlaanderen and ENIC-Naric Wallonia for academic recognition, and every tribunal de première instance. The Belgian Embassy in Bangkok will stop legalising Thai documents on 28 February 2027.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "naati-uk-us-canada-acceptance-2026",
  "title": "Is NAATI Accepted in the UK, US, and Canada? 2026 Guide (ATA, CTTIC, ITI/CIOL)",
  "category": "Translation",
  "tags": [
   "naati",
   "ata",
   "cttic",
   "iti",
   "uscis",
   "ircc",
   "ukvi"
  ],
  "readMinutes": 10,
  "excerpt": "NAATI accreditation is the gold standard inside Australia and New Zealand. For USCIS, IRCC, and UKVI, decision-makers prefer ATA, CTTIC, or ITI/CIOL credentials — or an MFA Apostille paired with a destination-country sworn translation.",
  "author": "NYC Translation Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "vietnam-document-legalization-corridor-en-2026",
  "title": "Thailand → Vietnam Document Legalisation Corridor 2026 (Non-Hague Chain)",
  "category": "Legalization",
  "tags": [
   "vietnam",
   "embassy",
   "legalization",
   "trc",
   "work-permit"
  ],
  "readMinutes": 9,
  "excerpt": "Vietnam is not a Hague Apostille party — Thai documents still require the full chain: MFA + Vietnamese Embassy Bangkok + Cục Lãnh sự before use at Sở Tư pháp/DOLISA.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "indonesia-document-legalization-corridor-en-2026",
  "title": "Thailand → Indonesia Document Legalisation Corridor 2026 (Hague Apostille Since June 2022)",
  "category": "Legalization",
  "tags": [
   "indonesia",
   "apostille",
   "kitas",
   "imta",
   "disdukcapil"
  ],
  "readMinutes": 8,
  "excerpt": "Indonesia is a Hague Apostille member since 4 June 2022 and Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027) — Thai documents use MFA Apostille directly without KBRI Bangkok legalisation.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "philippines-document-legalization-corridor-en-2026",
  "title": "Thailand → Philippines Document Legalisation Corridor 2026 (Hague Apostille Since May 2019)",
  "category": "Legalization",
  "tags": [
   "philippines",
   "apostille",
   "acr-icard",
   "aep",
   "ched",
   "psa"
  ],
  "readMinutes": 8,
  "excerpt": "Philippines has been a Hague Apostille member since 14 May 2019 and Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027) — Thai documents use Apostille directly for BI, DOLE, PSA, CHED, PRC.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "malaysia-document-legalization-corridor-en-2026",
  "title": "Thailand → Malaysia Document Legalisation Corridor 2026 (Non-Hague + High Commission Bangkok)",
  "category": "Legalization",
  "tags": [
   "malaysia",
   "embassy",
   "ep-pass",
   "mm2h",
   "jpn",
   "wisma-putra"
  ],
  "readMinutes": 9,
  "excerpt": "Malaysia is not a Hague Apostille party — Thai documents still require the full chain: MFA + High Commission of Malaysia Bangkok + Wisma Putra Putrajaya for EP, DP, MM2H, and JPN filings.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "sri-lanka-document-legalization-corridor-en-2026",
  "title": "Thai → Sri Lanka 2026: Apostille Now Accepted After 5 Jan 2025",
  "category": "Legalization",
  "tags": [
   "sri-lanka",
   "apostille",
   "ugc",
   "registrar-general",
   "immigration-lk"
  ],
  "readMinutes": 9,
  "excerpt": "Sri Lanka acceded to the Hague Apostille Convention with effect from 5 January 2025 and Thailand on 28 February 2027 — Thai documents now require only an MFA Apostille for the Department of Immigration & Emigration, Registrar General Department, and University Grants Commission.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "bangladesh-document-legalization-corridor-en-2026",
  "title": "Thai → Bangladesh 2026: BIDA, Bangladesh Bank, Registrar Office",
  "category": "Legalization",
  "tags": [
   "bangladesh",
   "embassy",
   "bida",
   "work-permit-bd",
   "mofa-dhaka"
  ],
  "readMinutes": 9,
  "excerpt": "Bangladesh has not joined the Hague Apostille Convention — Thai documents still require the full chain: MFA + Embassy of Bangladesh Bangkok (Thonglor) + MOFA Dhaka before BIDA, Bangladesh Bank, or the Registrar Office accept them.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "pakistan-document-legalization-corridor-en-2026",
  "title": "Thai → Pakistan 2026: NADRA, FIA, MOFA Islamabad",
  "category": "Legalization",
  "tags": [
   "pakistan",
   "embassy",
   "nadra",
   "fia",
   "mofa-islamabad",
   "muslim-family-laws"
  ],
  "readMinutes": 9,
  "excerpt": "Pakistan has not acceded to the Hague Apostille Convention — Thai documents still require the full chain: MFA + Embassy of Pakistan Bangkok (Sukhumvit 31) + MOFA Islamabad before NADRA, FIA, BISP, or the Board of Revenue accept them.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "nepal-document-legalization-corridor-en-2026",
  "title": "Thai → Nepal 2026: DAO Marriage, CRO Company, Immigration",
  "category": "Legalization",
  "tags": [
   "nepal",
   "embassy",
   "cro-nepal",
   "dao",
   "mofa-kathmandu",
   "singha-durbar"
  ],
  "readMinutes": 9,
  "excerpt": "Nepal has not acceded to the Hague Apostille Convention — Thai documents require the full chain: MFA + Embassy of Nepal Bangkok + MOFA Kathmandu (Singha Durbar) before the Department of Immigration, the Company Registrar Office (CRO), or the District Administration Office (DAO) for marriage accept them.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "brazil-document-legalization-corridor-en-2026",
  "title": "Thailand → Brazil 2026: Apostille, Cartório, Receita Federal, INM",
  "category": "Legalization",
  "tags": [
   "brazil",
   "apostille",
   "cartorio",
   "receita-federal",
   "tradutor-juramentado"
  ],
  "readMinutes": 9,
  "excerpt": "Brazil acceded to the Hague Apostille Convention with effect from 14 August 2016. Thai MFA Apostille is accepted directly by Receita Federal, Cartório, Polícia Federal and Junta Comercial. The Brazilian Embassy in Bangkok ceased Thai-document legalisation in 2016.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "mexico-document-legalization-corridor-en-2026",
  "title": "Thailand → Mexico 2026: Apostille, INM, Registro Civil, SAT",
  "category": "Legalization",
  "tags": [
   "mexico",
   "apostille",
   "inm",
   "registro-civil",
   "perito-traductor"
  ],
  "readMinutes": 9,
  "excerpt": "Mexico acceded to the Hague Apostille Convention with effect from 14 August 1995. Thai MFA Apostille is accepted directly by INM (immigration), Registro Civil, SAT (tax) and Notario Público across all 32 states.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "south-africa-document-legalization-corridor-en-2026",
  "title": "Thailand → South Africa 2026: Apostille, DHA, CIPC, SAQA",
  "category": "Legalization",
  "tags": [
   "south-africa",
   "apostille",
   "home-affairs",
   "cipc",
   "saqa"
  ],
  "readMinutes": 8,
  "excerpt": "South Africa acceded to the Hague Apostille Convention with effect from 30 April 1995 under the Hague Convention Act 8 of 1996. Thai MFA Apostille is accepted directly by DHA (visa), CIPC (company), DIRCO and SARS.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "egypt-document-legalization-corridor-en-2026",
  "title": "Thailand → Egypt 2026: MFA + Embassy + MOFA Cairo, GAFI, Maazoun",
  "category": "Legalization",
  "tags": [
   "egypt",
   "embassy",
   "gafi",
   "mofa-cairo",
   "maazoun"
  ],
  "readMinutes": 9,
  "excerpt": "Egypt has not joined the Hague Apostille Convention. Thai documents require the full chain: MFA + Embassy of Egypt in Bangkok (Thonglor Soi 10) + MOFA Cairo (Tahrir) before GAFI, Notary Public Egypt, Personal Status Court or the Ministry of Manpower.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "nigeria-document-legalization-corridor-en-2026",
  "title": "Thai → Nigeria Document Corridor 2026: MFA + Embassy + MOFA Abuja",
  "category": "Legalization",
  "tags": [
   "nigeria",
   "embassy",
   "cac",
   "mofa-abuja",
   "nis"
  ],
  "readMinutes": 8,
  "excerpt": "Nigeria has not joined the Hague Apostille Convention. Thai documents must complete the full chain: MFA Thailand + Embassy of Nigeria Bangkok (Sathorn) + MOFA Abuja before use at CAC, NIS, Federal High Court or Marriage Registry.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "kenya-document-legalization-corridor-en-2026",
  "title": "Thai → Kenya Document Corridor 2026: Apostille Hague Direct",
  "category": "Legalization",
  "tags": [
   "kenya",
   "apostille",
   "ecitizen",
   "kra",
   "hague-2025"
  ],
  "readMinutes": 8,
  "excerpt": "Kenya acceded to the Hague Apostille Convention on 14 January 2025. Thai documents bearing an MFA Apostille are accepted directly at eCitizen, KRA, Registrar of Companies — no Embassy of Kenya Bangkok step required.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "argentina-document-legalization-corridor-en-2026",
  "title": "Thai → Argentina Corridor 2026: Apostille + Traductor Público",
  "category": "Legalization",
  "tags": [
   "argentina",
   "apostille",
   "registro-civil",
   "afip",
   "igj"
  ],
  "readMinutes": 8,
  "excerpt": "Argentina has been a Hague Apostille member since 18 February 1988. Thai MFA Apostille is accepted directly at Registro Civil, AFIP, IGJ — but Spanish translation must be done in Argentina by a Traductor Público Juramentado registered with CTPCBA.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "chile-document-legalization-corridor-en-2026",
  "title": "Thai → Chile Corridor 2026: Apostille + Traductor Oficial",
  "category": "Legalization",
  "tags": [
   "chile",
   "apostille",
   "registro-civil",
   "sii",
   "cbr"
  ],
  "readMinutes": 8,
  "excerpt": "Chile acceded to the Hague Apostille Convention on 30 August 2016. Thai MFA Apostille is accepted directly at Registro Civil, SII, CBR — but Spanish translation must be done in Chile by a Traductor Oficial registered with the Ministerio de Relaciones Exteriores.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "russia-document-legalization-corridor-en-2026",
  "title": "Thailand → Russia Legalisation 2026: Apostille + Notariat",
  "category": "Legalization",
  "tags": [
   "russia",
   "apostille",
   "zags",
   "rosreestr",
   "notariat"
  ],
  "readMinutes": 9,
  "excerpt": "The Russian Federation succeeded the USSR's Hague Apostille membership on 31 May 1992. Thai MFA Apostille is accepted directly by ZAGS, Rosreestr, FNS, Notariat — but Russian Sworn Translation + Notarius certification is mandatory under Fundamental Notarial Law 4462-1/1993.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "turkey-document-legalization-corridor-en-2026",
  "title": "Thailand → Türkiye Legalisation 2026: Apostille + Noter",
  "category": "Legalization",
  "tags": [
   "turkey",
   "apostille",
   "nufus",
   "tapu",
   "yeminli-tercuman"
  ],
  "readMinutes": 9,
  "excerpt": "Türkiye Cumhuriyeti joined Hague Apostille on 29 September 1985. Thai MFA Apostille is accepted directly by Nüfus (civil registry), Tapu Sicil (land registry), MERSİS (company registry), and Noter nationwide. Türkçe translation by Yeminli Tercüman + Noter Tasdiki is mandatory under Notarial Law 1512/1972.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "israel-document-legalization-corridor-en-2026",
  "title": "Thailand → Israel Legalisation 2026: Apostille + Notary",
  "category": "Legalization",
  "tags": [
   "israel",
   "apostille",
   "misrad-hapnim",
   "rabbinical-court",
   "tabu"
  ],
  "readMinutes": 9,
  "excerpt": "The State of Israel joined Hague Apostille on 14 August 1978. Thai MFA Apostille is accepted directly by Misrad Hapnim (Interior Ministry), Tabu (Land Registry), PIBA (Population & Immigration), Rabbinical Court — but Hebrew translation + Notary Israel per Notaries Law 5736-1976 is mandatory.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "saudi-arabia-document-legalization-corridor-en-2026",
  "title": "Thailand → Saudi Arabia Legalisation 2026: MOFA + Tasdeeq",
  "category": "Legalization",
  "tags": [
   "saudi-arabia",
   "embassy",
   "tasdeeq",
   "qiwa",
   "vision-2030"
  ],
  "readMinutes": 9,
  "excerpt": "The Kingdom of Saudi Arabia is not a Hague Apostille member. Thai documents must complete the full chain: MFA + Embassy of Saudi Arabia Bangkok (Sathorn 12) + Tasdeeq MOFA Riyadh before being accepted by MOL Qiwa, MOJ Najiz, Absher, MOH (Iqama, Family Visit, Work Permit) under Vision 2030 digital reforms.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "iran-document-legalization-corridor-en-2026",
  "title": "Thai Documents → Iran 2026: MFA + Embassy + MOFA Tehran Tasdiq",
  "category": "Legalization",
  "tags": [
   "iran",
   "embassy",
   "tasdiq",
   "mahzar",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "The Islamic Republic of Iran has not joined the Hague Apostille Convention. Thai documents must complete the three-stage Tasdiq chain (MFA Thailand + Embassy of Iran Bangkok + MOFA Tehran) before use with Sazman-e Sabt-e Ahval (Civil Registry), Mahzar (Notary Public), NAJA, Sazman-e Sabt-e Asnad va Amlak under Civil Code 1928 and Notaries Law 1316/1937. Sanctions screening (OFAC SDN, EU CFSP, UK OFSI) is mandatory.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "iraq-document-legalization-corridor-en-2026",
  "title": "Thai Documents → Iraq 2026: MFA + Embassy + MOFA Baghdad",
  "category": "Legalization",
  "tags": [
   "iraq",
   "embassy",
   "tasdiq",
   "baghdad",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "The Republic of Iraq has not joined the Hague Apostille Convention. Thai documents must complete the chain MFA + Embassy of Iraq Bangkok + Tasdiq MOFA Baghdad (Green Zone Authentication Department) before use with Da'irat Al-Ahwal Al-Madaniya (Civil Status), Catasta (Land Registry), MOLSA, Kimadia (MOH), MOHESR under Civil Code 40/1951 + Personal Status Law 188/1959. KRG (Erbil) follows a separate procedure.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "jordan-document-legalization-corridor-en-2026",
  "title": "Thai Documents → Jordan 2026: MFA + Embassy + MOFA Amman",
  "category": "Legalization",
  "tags": [
   "jordan",
   "embassy",
   "tasdiq",
   "amman",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "The Hashemite Kingdom of Jordan has not joined the Hague Apostille Convention. Thai documents must complete the chain MFA + Embassy of Jordan Bangkok + Tasdiq MOFA Amman (4th Circle, Department of Authentication) before use with Da'irat Al-Ahwal Al-Madaniya wa Al-Jawazat, MOL (Tasreeh Amal), Sharia Court, Department of Lands and Survey under Civil Code 43/1976 + Personal Status Law 36/2010. ASEZA (Aqaba) operates a special-zone fast track.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "lebanon-document-legalization-corridor-en-2026",
  "title": "Thai Documents → Lebanon 2026: MFA + Embassy + MOFA Beirut",
  "category": "Legalization",
  "tags": [
   "lebanon",
   "embassy",
   "tasdiq",
   "beirut",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "The Lebanese Republic has not joined the Hague Apostille Convention. Thai documents must complete the chain MFA + Embassy of Lebanon Bangkok + Tasdiq MOFA Beirut (Achrafieh) + the relevant confessional court among 18 sects (Maronite, Sunni, Shia, Druze, etc.) under Decree 60/L.R. 1936. Bangkok only hosts an Honorary Consulate; certified legalisation routes via Kuala Lumpur or Riyadh.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "qatar-document-legalization-corridor-en-2026",
  "title": "Thailand → Qatar Document Legalisation 2026: MFA + Embassy + MOFA Doha",
  "category": "Legalization",
  "tags": [
   "qatar",
   "embassy",
   "tasdiq",
   "doha",
   "non-hague",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "The State of Qatar has not signed the Hague Apostille Convention 1961. Thai documents require the three-stage Tasdiq chain: source-country MFA + Embassy of Qatar + MOFA Doha Authentication Department before acceptance by MOI (Metrash2/Hukoomi), MADLSA, MOPH (DHP), Sharia Court, and QFC under Civil Code 22/2004 and Family Law 22/2006.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "kuwait-document-legalization-corridor-en-2026",
  "title": "Thailand → Kuwait Document Legalisation 2026: MFA + Embassy + MOFA Kuwait City",
  "category": "Legalization",
  "tags": [
   "kuwait",
   "embassy",
   "tasdiq",
   "non-hague",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "The State of Kuwait has not signed the Hague Apostille Convention 1961. Thai documents require the three-stage Tasdiq chain before acceptance by Public Authority of Manpower (PAM), MOI, MOH, and the Family Court (Mahkamat Al-Usra) under Civil Code 67/1980 and Personal Status Law 51/1984.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "oman-document-legalization-corridor-en-2026",
  "title": "Thailand → Oman Document Legalisation 2026: MFA + Embassy + MOFA Muscat",
  "category": "Legalization",
  "tags": [
   "oman",
   "embassy",
   "tasdiq",
   "muscat",
   "non-hague",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "The Sultanate of Oman has not signed the Hague Apostille Convention 1961. Thai documents require MFA + Embassy of Oman Bangkok + MOFA Muscat Tasdiq (Al Khuwair) before MoL (Invest Easy), Royal Oman Police (ROP), MOH (Sahaty), Sharia Court, and MOHERI under Basic Law 101/1996 and Personal Status Law 32/1997.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "bahrain-document-legalization-corridor-en-2026",
  "title": "Thailand → Bahrain Document Legalisation 2026: Apostille + Arabic Translation Manama",
  "category": "Legalization",
  "tags": [
   "bahrain",
   "apostille",
   "hague",
   "manama",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "The Kingdom of Bahrain joined the Hague Apostille Convention 1961 effective 31 Dec 2013 — the only GCC member. Thai documents bearing an MFA Apostille are accepted directly by LMRA, MOI eKey, NHRA, Sharia Court, SLRB, MOE Equivalency, EDB, and CBB, with no Embassy of Bahrain step required — 60% faster and 50% cheaper than Saudi/UAE/Qatar/Kuwait/Oman.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "syria-document-legalization-corridor-en-2026",
  "title": "Syria Document Legalisation Corridor 2026 — Chain, Sanctions, and War-Zone Risk",
  "category": "Legalization",
  "tags": [
   "syria",
   "tasdiq",
   "sanctions",
   "ofac",
   "embassy-legalization"
  ],
  "readMinutes": 16,
  "excerpt": "Syria is FCDO Red + OFAC CAESAR sanctioned, but ordinary Personal Status documents can still be legalised via Beirut or Amman if sanctions screening clears.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "yemen-document-legalization-corridor-en-2026",
  "title": "Yemen Document Legalisation Corridor 2026 — ROYG Aden vs Houthi Sana'a",
  "category": "Legalization",
  "tags": [
   "yemen",
   "tasdiq",
   "sanctions",
   "houthi",
   "embassy-legalization"
  ],
  "readMinutes": 14,
  "excerpt": "Yemen has two governments — ROYG (Aden, UN-recognised) and Houthi (Sana'a, not recognised). The chain depends on which government issued the document.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "libya-document-legalization-corridor-en-2026",
  "title": "Libya Document Legalisation Corridor 2026 — GNU Tripoli vs HoR Tobruk",
  "category": "Legalization",
  "tags": [
   "libya",
   "tasdiq",
   "sanctions",
   "embassy-legalization"
  ],
  "readMinutes": 14,
  "excerpt": "Libya has two governments — GNU Tripoli (UN-recognised) and HoR Tobruk + LNA Haftar. The chain depends on the document's destination.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "palestine-document-legalization-corridor-en-2026",
  "title": "Palestine Document Legalisation Corridor 2026 — PA Ramallah vs Hamas Gaza",
  "category": "Legalization",
  "tags": [
   "palestine",
   "tasdiq",
   "embassy-legalization",
   "west-bank",
   "gaza"
  ],
  "readMinutes": 14,
  "excerpt": "Palestine splits into two areas — PA West Bank (Ramallah-based) and Gaza (Hamas-controlled since 2007). The chain depends on destination + Israel COGAT coordination.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 }
] as BlogCardMeta[];
